export default {
  'jpg': 'image/jpeg',
  'png': 'image/png',
  'gif': 'image/gif',
  'svg': 'image/svg+xml',
  'psd': 'image/photoshop'
}



// WEBPACK FOOTER //
// ./src/components/AvatarCropper/utils/mimes.js